// Oberflächen-Manifest des Moduls Inventur: Routen, Navigation „Lager → Inventur“, Bausteine der Startseite, Befehle,
// Verknüpfungen. Wird von scripts/gen-registry.ts in Node geladen: Seiten und Bausteine nur per lazy-Import.
import { defineWebModule } from '@web/module'
import { ClipboardCheck, ClipboardList, ListChecks } from 'lucide-react'
import { STOCK_FEATURE } from '@shared/stock'
import { overviewRunning } from '../contract'

const READ = 'stocktaking.count.read'
const CREATE = 'stocktaking.count.create'
const ENTER = 'stocktaking.count.enter'
/** Funktionsschalter „Bestandsführung“ (docs/ohne-lager/SPEZIFIKATION.md): Ohne ihn gibt es keine Inventur in der Oberfläche. */
const STOCK = STOCK_FEATURE

export default defineWebModule({
  id: 'stocktaking',
  routes: [
    { path: '/stock/counts', title: 'Inventur', permission: READ, feature: STOCK, lazy: () => import('./pages/CountListPage') },
    { path: '/stock/counts/new', title: 'Inventur planen', permission: CREATE, feature: STOCK, lazy: () => import('./pages/CountPlanPage') },
    { path: '/stock/counts/rolling', title: 'Permanente Inventur', permission: READ, feature: STOCK, lazy: () => import('./pages/RollingPage') },
    { path: '/stock/counts/:id', title: 'Inventur', permission: READ, feature: STOCK, lazy: () => import('./pages/CountPage') },
    { path: '/stock/counts/:id/edit', title: 'Zählplan ändern', permission: CREATE, feature: STOCK, lazy: () => import('./pages/CountPlanPage') },
    { path: '/stock/counts/:id/count', title: 'Zählen', permission: ENTER, feature: STOCK, layout: 'fullscreen', lazy: () => import('./pages/CountingPage') },
    { path: '/stock/counts/:id/print', title: 'Inventur drucken', permission: READ, feature: STOCK, lazy: () => import('./pages/CountRecordsPage') },
  ],
  nav: [{ section: 'stock', label: 'Inventur', icon: ClipboardCheck, to: '/stock/counts', permission: READ, feature: STOCK, order: 60, badge: { query: overviewRunning, tone: 'accent' } }],
  widgets: [
    { id: 'stocktaking.running', title: 'Laufende Inventuren', permission: READ, feature: STOCK, size: 'md', order: 140, lazy: () => import('./widgets/RunningCountsWidget') },
    { id: 'stocktaking.rollingDue', title: 'Permanente Inventur', permission: READ, feature: STOCK, size: 'md', order: 150, lazy: () => import('./widgets/RollingDueWidget') },
  ],
  commands: [
    { id: 'stocktaking.plan', label: 'Inventur planen', keywords: ['Zählung', 'Zählplan', 'Stichtag', 'Kontrollzählung', 'zählen'], icon: ClipboardList, to: '/stock/counts/new', permission: CREATE, feature: STOCK },
    { id: 'stocktaking.list', label: 'Inventuren öffnen', keywords: ['Zählung', 'Differenzen', 'Inventurliste', 'zählen'], icon: ClipboardCheck, to: '/stock/counts', permission: READ, feature: STOCK },
    { id: 'stocktaking.rolling', label: 'Permanente Inventur: Stand anzeigen', keywords: ['rollierend', 'fällig', 'noch nicht gezählt', 'Geschäftsjahr'], icon: ListChecks, to: '/stock/counts/rolling', permission: READ, feature: STOCK },
  ],
  entityLinks: {
    'document:stock_count': (id) => `/stock/counts/${id}`,
  },
})
